import { render, staticRenderFns } from "./ContactNotify.vue?vue&type=template&id=5e49e2ae&scoped=true&"
import script from "./ContactNotify.vue?vue&type=script&lang=js&"
export * from "./ContactNotify.vue?vue&type=script&lang=js&"
import style0 from "./ContactNotify.vue?vue&type=style&index=0&id=5e49e2ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e49e2ae",
  null
  
)

export default component.exports